/**
 * Bahadura & Besa Branch Feature Flags
 */
export const branchFeatureFlags = {
  ENABLE_TWO_STAGE_WORKFLOW: true,
  ENABLE_L2_DEMAND_NOTE_GENERATION: true,
  ENABLE_TEMPORARY_RL_CERTIFICATE: true,
  ENABLE_PHASE2_PERMANENT_RL_UPLOAD: true,
  // Feature flag to control whether Level 2 shows the "Upload Map After Digital Signature" screen.
  // Set to false to bypass UploadMapWrapper and navigate directly to /level-2-applications upon forwarding.
  ENABLE_L2_UPLOAD_MAP_SCREEN: false,
};
